<template>
    <div id="91kefu_div" class="kefu">
        <!-- <iframe id="91kefu_iframe" src="/static/kefu.html" frameborder="0" scrolling="no" style="width: 100%; height: 100%;" allowtransparency="true" ref="kefu_iframe" /> -->
    </div>
</template>

<script>
export default {
    name: 'KeFu',
    data () {
        return {
            uid: '',
            nickname: '',
        }
    },
    created() {
        this.$util.api('/login/status',{},res => {
            if(res.code == 10000){
                this.uid = res.data.id;
                this.nickname = res.data.nickname;
            }
        });
    },
    mounted() {
        
    },
    methods: {
        open (ext = '') {
            var uid = this.uid;
            var nickname = this.nickname;
            
            if(document.getElementById("91kefu_iframe") != null){
                var iframe = document.getElementById("91kefu_iframe");
            }else{
                var iframe = document.createElement('iframe');

                iframe.src = '/static/kefu.html';
                iframe.height = '100%';
                iframe.width = '100%';
                iframe.id = '91kefu_iframe';
                iframe.frameBorder = 0;
                iframe.scrolling = 'no';
                iframe.allowtransparency = true;
                document.getElementById("91kefu_div").appendChild(iframe);
            }
            
            var model = iframe.contentWindow.document.getElementById("KeFuModal");
            // console.log(model);
            if(model == null){
                if(iframe.attachEvent){
                    iframe.attachEvent('onload',function(){
                        iframe.contentWindow.kefu91(uid, nickname, ext)
                    });
                }else{
                    iframe.onload = function(){
                        iframe.contentWindow.kefu91(uid, nickname, ext)
                    }
                }
            }else{
                model.style.display = 'block';
                // 订单列表联系客服
                if(ext) {
                    iframe.contentWindow.kefu91(uid, nickname, ext)
                }
                // iframe.contentWindow.location.reload(true);
            }

            document.getElementById("91kefu_div").style.display = 'block';
        }
    }
}
</script>

<style scoped>
.kefu {
    width: 605px;
    height: 750px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    z-index: 9999;
    display:none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/KeFu.vue